let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fJojm")).then(() => parcelRequire('1S0Rp'));